var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";
import { Link } from "react-router-dom";
import Button from "../Button";
import { sliceString } from "../../theme/helpers";
import { Title, Description, BanerDefault, BanerBig, BanerArticle } from "./Baner.styled";

var BanerWrapper = function BanerWrapper(props) {
  if (props.type === "article") {
    return React.createElement(BanerArticle, __assign({}, props));
  }

  if (props.type === "big") {
    return React.createElement(BanerBig, __assign({}, props));
  }

  return React.createElement(BanerDefault, __assign({}, props));
};

var Baner = function Baner(_a) {
  var type = _a.type,
      title = _a.title,
      description = _a.description,
      url = _a.url,
      label = _a.label,
      coverUrl = _a.coverUrl,
      className = _a.className;
  var isExternal = url.includes("http") || url.includes("www");
  return React.createElement(BanerWrapper, {
    type: type,
    coverUrl: coverUrl,
    className: className
  }, React.createElement("div", null, React.createElement(Title, null, sliceString(title, 52)), !!description && React.createElement(Description, null, sliceString(description, 128))), isExternal ? React.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(Button, {
    isPrimary: true,
    isFullWidth: false,
    hasArrow: false
  }, label)) : React.createElement(Link, {
    to: url
  }, React.createElement(Button, {
    isPrimary: true,
    isFullWidth: false,
    hasArrow: false
  }, label)));
};

export default Baner;